import { render } from "./ObjectsTable.vue?vue&type=template&id=e0b2436c&scoped=true"
import script from "./ObjectsTable.vue?vue&type=script&lang=js"
export * from "./ObjectsTable.vue?vue&type=script&lang=js"

import "./ObjectsTable.vue?vue&type=style&index=0&id=e0b2436c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b2436c"]])

export default __exports__